import type { AbilityBuilder } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineClientAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can } = abilityBuilder

  can('read', 'projects')
  can('read', 'projects-id-view')

  const roles = userRoles(user)

  if (roles.administrator || roles.client_lead) {
    can('read', 'clients')
    can('read', 'clients-id-view')
    can(['create', 'read', 'update', 'delete', 'restore'], 'client')
  }
}
